import {connect} from 'react-redux';

import Sports from '../Sports.jsx';

function select(state, props) {
    return {
        ...props,
        isLive: true
    };
}

export default connect(select, null, null, false)(Sports);


// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/live/Sports.jsx